// extracted by mini-css-extract-plugin
export default {"articleLink":"bc_bQ","standout":"bc_cZ","articleTitle":"bc_bS","articleBody":"bc_c0","articleCoverImage":"bc_bR","articleDate":"bc_c1"};